import React from "react";
import { Link, NavLink } from "react-router-dom";
import "../pages/Pricing/Pricing.css";
import { useDispatch, useSelector } from "react-redux";
import { logoutAction } from "../redux/actions/auth.action";
import "bootstrap/dist/css/bootstrap.min.css";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { menuItems } from "content/static";
import Dropdown from 'react-bootstrap/Dropdown';


const MegaNavbar = () => {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const logOut = (e) => {
    e.preventDefault();
    dispatch(logoutAction());
  };
  return (
    <>
      <Navbar
        collapseOnSelect
        expand="lg"
        bg="dark"
        variant="dark"
        className="shadow-sm"
      >
        <Container fluid>
          <Navbar.Brand as={Link} to="/">
            <img
              alt="profile-img"
              className="d-inline-block align-top"
              src="../assets/Logo White.png"
              style={{ height: "60px" }}
            />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-between">
            <Nav className="me-4">
              {menuItems[user.role]?.map((item) => (
                <Nav.Link
                  as={NavLink}
                  to={item.path}
                  className="px-3 text-uppercase"
                  key={item.path}
                >
                  {item.label}
                </Nav.Link>
              ))}

            </Nav>

            <Nav className="align-items-center">
              <Dropdown className="ms-2">
                <Dropdown.Toggle
                  variant="dark"
                  id="dropdown-profile"
                  className="d-flex align-items-center"
                  style={{
                    color: "white",
                    border: "none",
                    background: "transparent"
                  }}
                >
                  <img
                    alt="profile"
                    style={{ width: "25px", height: "25px", marginRight: "10px" }}
                    src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
                  />
                  {user.firstname}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item as={Link} to="/profileDetails">
                    Profile
                  </Dropdown.Item>
                  {/* <Dropdown.Item href="#settings">Settings</Dropdown.Item> */}
                  <Dropdown.Divider />
                  <Dropdown.Item
                    as="button"
                    onClick={logOut}
                    style={{ width: '100%', textAlign: 'left' }}
                  >
                    Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default MegaNavbar;
